var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable } from '../../../Data/Decorators/Injectable';
import { reactive } from '../../Decorators/Reactive';
import { inject } from '../../../Data/Decorators/Inject';
import { ISendDidDismissEventUseCaseType } from '../../../Domain/UseCases/Events/SendDidDismissEventUseCase/ISendDidDismissEventUseCase';
import { IGetColorSchemeUseCaseType } from '../../../Domain/UseCases/Theme/GetColorSchemeUseCase/IGetColorSchemeUseCase';
import { IGetTransparentHeaderUseCaseType } from '../../../Domain/UseCases/Theme/GetTransparentHeaderUseCase/IGetTransparentHeaderUseCase';
import { IGetConfigurationUseCaseType } from '../../../Domain/UseCases/Configuration/GetConfigurationUseCase/IGetConfigurationUseCase';
import { ISendScreenEventUseCaseType } from '../../../Domain/UseCases/Application/SendScreenEventUseCase/ISendScreenEventUseCase';
import { ICoordinatorServiceType } from '../../../Domain/Services/CoordinatorService/ICoordinatorService';
let BaseScreenViewModel = class BaseScreenViewModel {
    constructor(sendDidDismiss, getColorSchemeUseCase, getTransparentHeader, getConfiguration, sendScreenEvent, coordinatorService) {
        var _a, _b, _c, _d;
        this.sendDidDismiss = sendDidDismiss;
        this.getColorSchemeUseCase = getColorSchemeUseCase;
        this.getTransparentHeader = getTransparentHeader;
        this.getConfiguration = getConfiguration;
        this.sendScreenEvent = sendScreenEvent;
        this.coordinatorService = coordinatorService;
        this.viewData = {
            document_title: ((_c = (_b = (_a = this.getConfiguration.configuration.value) === null || _a === void 0 ? void 0 : _a.meta_properties) === null || _b === void 0 ? void 0 : _b.share) === null || _c === void 0 ? void 0 : _c.title) || ((_d = this.getConfiguration.configuration.value) === null || _d === void 0 ? void 0 : _d.brand_name) || '',
            transparent_header: this.getTransparentHeader.execute().value
        };
        this.getConfiguration.configuration.observe(this, value => {
            var _a, _b;
            this.updateViewData({ document_title: ((_b = (_a = value === null || value === void 0 ? void 0 : value.meta_properties) === null || _a === void 0 ? void 0 : _a.share) === null || _b === void 0 ? void 0 : _b.title) || (value === null || value === void 0 ? void 0 : value.brand_name) || '' });
        });
        this.getTransparentHeader.execute().observe(this, transparent_header => this.updateViewData({ transparent_header }));
        this.getColorScheme = this.getColorScheme.bind(this);
    }
    submitScreenEvent(value) {
        const params = this.coordinatorService.getCurrentRouteParams();
        if (!params.path) {
            return Promise.resolve();
        }
        return this.sendScreenEvent.execute({
            view: params.params,
            path: params.path,
            title: value.title
                ? `${this.viewData.document_title}${!!value.title ? ' - ' : ''}${value.title || ''}`
                : undefined
        });
    }
    getColorScheme(moduleName, componentName) {
        if (!moduleName || !componentName) {
            return {
                scheme: 'default'
            };
        }
        return this.getColorSchemeUseCase.execute(moduleName, componentName);
    }
    didDismiss(moduleName) {
        return this.sendDidDismiss.execute(moduleName);
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], BaseScreenViewModel.prototype, "viewData", void 0);
BaseScreenViewModel = __decorate([
    injectable(),
    __param(0, inject(ISendDidDismissEventUseCaseType)),
    __param(1, inject(IGetColorSchemeUseCaseType)),
    __param(2, inject(IGetTransparentHeaderUseCaseType)),
    __param(3, inject(IGetConfigurationUseCaseType)),
    __param(4, inject(ISendScreenEventUseCaseType)),
    __param(5, inject(ICoordinatorServiceType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object])
], BaseScreenViewModel);
export { BaseScreenViewModel };
